import React from 'react';
import { CommonProps } from '../../../interfaces/components';
import Restaurant from '../../../components/lavalle/Restaurant';
import Background from '../../../assets/images/lavalle/pierre.png';
import BackgroundMb from '../../../assets/images/lavalle/pierre_mb.png';
import { useTranslation } from 'react-i18next';

const PierreHerme = ({ active, setActive }: CommonProps) => {
  const { t } = useTranslation();

  return (
    <>
      <Restaurant
        active={active}
        setActive={setActive}
        title={t('lv_pierre_title')}
        description={t('lv_pierre_description')}
        cover={Background}
        coverMobile={BackgroundMb}
      />
    </>
  );
};

export default PierreHerme;
